
import BaseAlert from "@/components/base/BaseAlert.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import { validPassengers } from "@/composables/useBookingValidation";
import usePassengers from "@/composables/usePassengers";
import { allDestinations } from "@/config/global.strings";
import { passengerValidationTexts } from "@/helpers/validationTextHelper";
import { useBookingStore } from "@/store/booking";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { computed, defineComponent } from "vue";
import TripPassengerSelectQuantity from "./TripPassengerSelectQuantity.vue";
import { useUserStore } from "@/store/user";

export default defineComponent({
	components: {
		BaseSection,
		TripPassengerSelectQuantity,
		BaseAlert
	},
	props: {
		disabled: Boolean,
	},
	setup(props) {
		const { getBooking } = useBookingStore();
		const { getRegularPassengers, getShareholderPassengers } = usePassengers();
		const passengerTypes = getRegularPassengers();
		const shareholderPassengerTypes = getShareholderPassengers();
		const { getIsShareholder } = useUserStore();
		const shareholderAlert = "Scillonian discount applies to the shareholder and spouse / partner. Skybus discount applies to shareholder only.";

		const rules = {
			booking: {
				v: helpers.withMessage(() => {
					return passengerValidationTexts().join(".<br> ");
				}, validPassengers as any),
			},
		};

		const v$ = useVuelidate(rules, {
			booking: computed(() => {
				return getBooking;
			}),
		});		

		const isSectionEnable = computed(() => {
			return (
				(allDestinations.includes(getBooking.outward.from) &&
					allDestinations.includes(getBooking.outward.to)) ||
				getBooking.outward.passengers.length > 0
			);
		});

		const showShareholderPassengerBox = computed(() => {
			if(getIsShareholder.valueOf() === true) {
				return true;
			}
			else return false;
		})

		return { 
			passengerTypes,
			shareholderPassengerTypes, 
			v$, 
			isSectionEnable,
			showShareholderPassengerBox,
			shareholderAlert
		};
	},
});
